<div *ngIf="isMobileWeb"
     class="download-app-box d-flex ion-justify-content-between ion-align-items-center p-md">
  <div>{{ 'Download app' | translate }}</div>
  <div>
    <ion-button (click)="onDownloadApp()"
                style="color: white;" fill="clear">Scarica
    </ion-button>
  </div>
</div>
<ion-app [class.mt-6xl]="isMobileWeb">

  <ion-menu menuId="main-menu"
            #mainMenu
            contentId="main-content"
            side="start">
    <ion-header style="--background: var(--azzurro--600)">
      <ion-toolbar class="menu-toolbar">
        <div class="d-flex ion-justify-content-between py-xs">

          <ion-button (click)="onLogin()"
                      *ngIf="userService?.user?.isGuest" class="small outline white">
            <span class="material-symbols-outlined">person</span>
            <span>Accedi</span>
          </ion-button>

          <div (click)="onNavigateProfile()"
               class="text-font-color ts-caption-bold"
               *ngIf="!userService?.user?.isGuest">
            <div>{{ userService?.user?.name }} {{ userService?.user?.lastName }}</div>
            <div class="d-flex gap-2 ion-align-items-center">
              <div>Vai al profilo</div>
              <span style="font-size: 12px" class="material-symbols-outlined">arrow_forward_ios</span>
            </div>
          </div>


          <ion-button (click)="mainMenu.close()" fill="clear" class="small white">
            <span class="material-symbols-outlined">close</span>
          </ion-button>

        </div>
      </ion-toolbar>
    </ion-header>
    <ion-content class="white-background">
      <ion-menu-toggle>
        <div class="content-spacing">

          <div class="mb-sm" *ngFor="let key of sectionKeys">
            <div class="ts-body-bold ion-text-uppercase pb-sm">{{ key | translate }}</div>
            <div *ngFor="let item of groupped[key]"
                 (click)="onActionMenuItem(item.id, item.link)"
                 class="d-flex ion-justify-content-between ion-align-items-center pb-sm">

              <div class="d-flex gap-2 ion-align-items-center">
                <app-service-box-icon [size]="'small'"
                                      [key]="item.id"></app-service-box-icon>
                <div class="ts-body">{{ item.name | translate }}</div>
              </div>

              <div class="material-symbols-outlined text-neutral-400">chevron_right</div>
            </div>
            <hr class="app-divider">
          </div>

        </div>
      </ion-menu-toggle>
    </ion-content>
  </ion-menu>

  <ion-router-outlet id="main-content" [animation]="slideTransition"></ion-router-outlet>
</ion-app>
<div *ngIf="isStage"
     style="position: absolute; left: 0px;bottom:0px;background: #ff9633;font-size:9px;font-weight: 800;padding: 6px;">
  stage
</div>
<div *ngIf="showMainLoader || showTransparentLoader"
     [@fadeInOut]
     [class.transparent]="showTransparentLoader"
     class="main-spinner d-flex ion-align-items-center ion-justify-content-center">
  <ng-lottie width="200px"
             height="200px"
             [options]="lottieOptions"/>
</div>
<app-drawer-modal #positionDrawer>
  <div content>
    <div class="ts-caption"
         [innerHTML]="'Per_garantire_un_esperienza_ottimale_durante_la_visita_alla_città_di_Adria' | translate"></div>
    <div class="w-100 mt-sm">
      <ion-button class="w-100 neutral"
                  (click)="onIgnore()" fill="clear">{{ 'Non_visualizzare_più' | translate }}
      </ion-button>
    </div>
    <div class="w-100 mt-sm">
      <ion-button class="w-100" (click)="onOpenPositionPermission()">
        <div class="material-symbols-outlined pr-sm">my_location</div>
        {{ 'Continua' | translate }}
      </ion-button>
    </div>
  </div>
</app-drawer-modal>

<app-contact-drawer #contactDrawer></app-contact-drawer>

